import axios from "axios";
import setStudentSched from '../Actions/studentsScheduleAction'

export const sexamSchedule = () => {   
    return async function(dispatch) {
        try {
            const url = `${process.env.REACT_APP_UNIVERSAL_URL}/studentexamSchedule.php`;
            
            const response = await axios.get(url);
            
            // Handle successful response
            if (response.data) {
                // Ensure data is an array (in case API returns empty array or object)
                const scheduleData = Array.isArray(response.data) ? response.data : [];
                dispatch(setStudentSched(scheduleData));
            } else {
                // If no data, dispatch empty array
                dispatch(setStudentSched([]));
            }
        } catch (error) {
            // Handle errors gracefully
            console.error("Error fetching exam schedule:", error);
            
            // Dispatch empty array on error so app doesn't break
            dispatch(setStudentSched([]));
            
            // Optionally show error message to user
            if (error.response) {
                // Server responded with error status
                console.error("Server error:", error.response.status, error.response.data);
            } else if (error.request) {
                // Request made but no response received
                console.error("No response received:", error.request);
            } else {
                // Error setting up request
                console.error("Request setup error:", error.message);
            }
        }
    };
};


